/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import addressTranslations from "./addressTranslations";
import contactTranslations from "./contactTranslations";

const personTranslations = {
  gender: {
    label: "Anrede",
    options: {
      male: { label: "Herr" },
      female: { label: "Frau" },
      diverse:{label:"Divers"}
    },
  },
  givenName: {
    label: "Vorname",
  },
  familyName: {
    label: "Nachname",
  },
  nationality: {
    label: "Staatsangehörigkeit",
  },
  birthDate: {
    label: "Geburtsdatum",
    question: "Wann wurden Sie geboren?",
  },
  residenceAddress: addressTranslations,
  addresses: [addressTranslations],
  ...contactTranslations,
};

export default personTranslations;
